import React, { Component } from "react";
import PropTypes from "prop-types";
import AccordionSection from "./AccordionSection";

class Accordion extends Component {
  constructor(props) {
    super(props);

    const { children } = this.props;
    const openSections = {};
    React.Children.forEach(children, (child) => {
      if (child.props.isOpen) {
        openSections[child.props.label] = true;
      }
    });

    this.state = { openSections };
  }

  onClick = (label) => {
    const {
      props: { allowMultipleOpen },
      state: { openSections },
    } = this;

    const isOpen = !!openSections[label];

    if (allowMultipleOpen) {
      this.setState({
        openSections: {
          ...openSections,
          [label]: !isOpen,
        },
      });
    } else {
      this.setState({
        openSections: {
          [label]: !isOpen,
        },
      });
    }
  };

  render() {
    const {
      onClick,
      props: {
        as,
        bg,
        children,
        richResultSectionProps,
        richResultQuestionProps,
        activateOnHover,
      },
      state: { openSections },
    } = this;

    return (
      <div className="accordion-container">
        {React.Children.map(children, (child, index) => (
          <AccordionSection
            key={"accordion-section"+index}
            isOpen={!!openSections[child.props.label]}
            label={child.props.label}
            style={child.props.style}
            textStyle={child.props.textStyle}
            as={as}
            onClick={onClick}
            bg={bg}
            activateOnHover={activateOnHover}
            richResultSectionProps={richResultSectionProps}
            richResultQuestionProps={richResultQuestionProps}
            showChevronIcon={child.props.showChevronIcon}
            openIconName={child.props.openIconName}
            closeIconName={child.props.closeIconName}
            iconSize={child.props.iconSize}
            iconColor={child.props.iconColor}
            showUnderlinedQuestion={child.props.showUnderlinedQuestion}
            isElement={child.props.isElement}
            Element={child.props.Element}
          >
            {child.props.children}
          </AccordionSection>
        ))}
      </div>
    );
  }
}

Accordion.propTypes = {
  allowMultipleOpen: PropTypes.bool,
  as: PropTypes.string,
  bg: PropTypes.bool,
  children: PropTypes.instanceOf(Object).isRequired,
};

Accordion.defaultProps = {
  allowMultipleOpen: false,
  as: "h3",
  bg: false,
};

export default Accordion;
